import React from 'react'
import { Wrench } from 'lucide-react'
import { SessionManager } from '../../utils'

export default function ActionCorrective(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))

    return (
        <>
            {(permission?.some(val => val.sub_action_name == route_name)) &&
                <Wrench size={16} className='action-button text-warning me-2'
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-warning tooltip_msg"
                />
            }
        </>
    )
}
